module.exports = __webpack_public_path__ + "img/inspector_marshall_vol1.e2b97890.jpeg";